import { MypageNovelPostInputModel } from "./PostInputModel"
import { httpPost } from "../../../../libs/http/httpPost"

export const postMypageNovel = async (
  model: MypageNovelPostInputModel,
): Promise<{ id: number }> => {
  return httpPost<{ id: number }>("/v1/mypage/novel?is_r18=yes", model)
}
